export const AB_GROUP_CONTROL = 'control'
export const AB_GROUP_EXPERIMENT = 'variant_a'
export const AB_GROUP_NONE = 'out_of_scope'

export const REDIS_FIM_AB_KEY = 'EXPERIMENTS'
export const REDIS_FIM_AB_PREFIX = ':FIM_AB'
export const FIM_AB_NOT_SET = 'FIM_AB_NOT_SET'
export const FIM_AB_CACHE_TTL = 300 // 5 minutes

export const FIM_AB_HEADER_NAME = 'x-ab-experiments'
export const FIM_AB_SESS_COOKIE_NAME = 'expsessid'
export const FIM_AB_COOKIE_NAME = 'fim_test_version'
